import Vue from 'vue'
import Component from 'vue-class-component'
import { Products, DataEntity } from "@/entity/warehouse/Products/Products.types"
import { ProductsStore } from "@/store/modules/Warehouse/Products";

@Component
export class ProductsMix extends Vue {
    get products(): Products | null {
        return ProductsStore.products
    }
    get product(): DataEntity | null {
        return ProductsStore.product
    }
    async productById(id:number): Promise<{ product: DataEntity; productLoaded:boolean }> {
        return await  ProductsStore.fetchData({filter:{id:id}})
    }
}